import o from "react";
import p from "./SlackConnectedChannelTag.mjs";

const f = ({
  connectedChannels: e,
  slackChannels: r,
  updateConnectedChannels: m
}) => {
  const a = new Map(e == null ? void 0 : e.map((t) => [t.channel_id, t])), i = (r == null ? void 0 : r.filter((t) => a.has(t.id || ""))) || [];
  return /* @__PURE__ */ o.createElement("div", { className: "rsk-combobox__connected_channel_tag_list" }, i.map((t) => /* @__PURE__ */ o.createElement(p, { key: t.id, channel: t, updateConnectedChannels: m })));
};
export {
  f as default
};
//# sourceMappingURL=SlackConnectedChannelTagList.mjs.map
